import { selector } from './selector';
import * as events from "./events";

const PageCustomerProfilePrepaidBalance = (function ($) {

    function initEvents() {
        $(document).on('click', selector.btnViewTransactions, events.viewTransactions);
    }

    function initialize() {
        initEvents();
    }

    return {
        init: initialize
    }
})(jQuery);

export { PageCustomerProfilePrepaidBalance };
